import React from "react";
import { DeleteIcon, EditIcon } from "../Icons";
import DownloadIcon from "../Icons/DownloadIcon";
import ShareIcon from "../Icons/ShareIcon";
import { FileCardOptionsTypeEnum } from "app/components/MediaUploader/types";

export const options = [
  {
    label: "Rename",
    icon: <EditIcon size={20} color="#79808A" />,
    type: FileCardOptionsTypeEnum.IS_EDIT,
  },
  {
    label: "Copy URL",
    icon: <ShareIcon size="20" color="#79808A" />,
    type: FileCardOptionsTypeEnum.COPY_URL,
  },
  {
    label: "Download",
    icon: <DownloadIcon size="20" color="#79808A" />,
    type: FileCardOptionsTypeEnum.DOWNLOAD,
  },
  {
    label: "Delete",
    icon: <DeleteIcon size={20} color="#79808A" />,
    type: FileCardOptionsTypeEnum.IS_REMOVE,
  },
];
